export const fetchNotifs = resp => ({
  type: "FETCH_NOTIFS",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/notif.js